import request from "../../utils/request";

export function getCustomerLedger(params) {
  return request({
    url: "/customers",
    method: "get",
    params,
    timeout: 60000
  });
}

export function getLeadLedger(params) {
  return request({
    url: "/leads",
    method: "get",
    params,
    timeout: 60000
  });
}

export function refreshCustomerLedger() {
  return request({
    url: "/customers/refresh",
    method: "post",
    timeout: 120000
  });
}

export function getCustomerConversation(id, params) {
  return request({
    url: `/customers/${id}/conversation`,
    method: "get",
    params,
    timeout: 60000
  });
}

export function sendCustomerConversationMessage(id, data) {
  return request({
    url: `/customers/${id}/conversation/send`,
    method: "post",
    data,
    timeout: 120000
  });
}

export function getCustomerSummary(id) {
  return request({
    url: `/customers/${id}/summary`,
    method: "get",
    timeout: 60000
  });
}

export function updateCustomerAiSwitch(id, data) {
  return request({
    url: `/customers/${id}/ai-switch`,
    method: "put",
    data
  });
}

export function getCustomerAiSwitchStatuses(data) {
  return request({
    url: "/customers/ai-switch/statuses",
    method: "post",
    data,
    timeout: 30000
  });
}
